export default __webpack_public_path__ + "static/media/Career_Navigator_logo_Black.34e8c543.png";